import Masonry from 'masonry-layout';
export default function() {

	if ( document.querySelector( '.js-masonryGrid' ) ) {

		const grid = new Masonry( '.js-masonryGrid', {
			columnWidth: '.js-masonryGrid_sizer',
			itemSelector: '.js-masonryGrid_tile',
			percentPosition: true,
			horizontalOrder: true,
			gutter: 24,
		} );

	}

}
